import { ReactNode } from "react";
import { AlertTabs } from "@/routes/dashboard/settings/alert-management/alerts/$alertId/-alert-tabs.tsx";
import { useAlertsEnabled } from "../-alerts-enabled-context";

export const Layout = ({ children }: { children: ReactNode }) => {
  const alertsEnabled = useAlertsEnabled();

  return (
    <div
      className={
        !alertsEnabled
          ? "flex flex-col gap-4 p-4 opacity-50 pointer-events-none select-none"
          : "flex flex-col gap-4 p-4"
      }
    >
      <AlertTabs />
      {children}
    </div>
  );
};
